// Crisp live chat, for signed-in users only.
//
// The snippet used to sit in the Webflow head, so the widget started on every page
// before the route guard ran: an anonymous visitor (or a bot, 03/10 and 06/10/2026)
// got the chat on a protected page before being sent to /login. It is now started
// here, after the guard has confirmed a session, with the user's email already set
// so a member is never asked for it.

export const CRISP_WEBSITE_ID = "fbd2b197-9103-4b7e-8c77-2b4d61ec93b3"
const CRISP_SCRIPT = "https://client.crisp.chat/l.js"

type CrispWindow = Window & { $crisp?: unknown[][]; CRISP_WEBSITE_ID?: string }

/** Start the Crisp widget once per page, identified with the member's email. */
export function loadCrisp(email: string, win: CrispWindow = window, doc: Document = document): boolean {
  if (win.CRISP_WEBSITE_ID || doc.querySelector(`script[src="${CRISP_SCRIPT}"]`)) return false
  win.$crisp = []
  win.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID
  if (email) win.$crisp.push(["set", "user:email", [email]])
  const script = doc.createElement("script")
  script.src = CRISP_SCRIPT
  script.async = true
  doc.head.appendChild(script)
  return true
}
